var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewtravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.8V12H12V0H2C0.9 0 0 0.8 0 1.8Z",
    fill: "#465867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12V24H2C0.9 24 0 23.2 0 22.2V12H12Z",
    fill: "#FF7300"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.77499,
    width: 13.7406,
    height: 16.85,
    rx: 1.5,
    fill: "#E8E8E8",
    stroke: "#465867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9301 13.05H9.80511V11.925C9.80511 11.7922 9.68792 11.675 9.55511 11.675H9.30511C9.16448 11.675 9.05511 11.7922 9.05511 11.925V13.05H7.93011C7.78948 13.05 7.68011 13.1672 7.68011 13.3V13.55C7.68011 13.6906 7.78948 13.8 7.93011 13.8H9.05511V14.925C9.05511 15.0656 9.16448 15.175 9.30511 15.175H9.55511C9.68792 15.175 9.80511 15.0656 9.80511 14.925V13.8H10.9301C11.0629 13.8 11.1801 13.6906 11.1801 13.55V13.3C11.1801 13.1672 11.0629 13.05 10.9301 13.05Z",
    fill: "#465867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9893 3.58935C23.0811 4.27506 22.5695 4.92338 21.8773 5.11599C21.0777 5.33851 20.1624 5.57098 19.2235 5.79775C18.8465 6.50771 18.451 7.19379 18.1554 7.69336C17.8825 8.15447 17.3094 8.42885 16.7721 8.36612C16.1579 8.2944 15.7835 7.80612 15.922 7.24472C15.9762 7.02507 16.038 6.77902 16.1055 6.51715C15.1088 6.73825 14.2149 6.9293 13.5592 7.0673C12.9866 7.18783 12.4529 6.86678 12.3017 6.34104C12.2901 6.31416 12.2799 6.2863 12.2712 6.2575C12.0499 5.52079 11.8535 4.61764 11.7207 3.94953C11.6125 3.40459 11.943 2.85696 12.4844 2.66106C13.0259 2.46516 13.6165 2.67953 13.8632 3.17439C14.0327 3.51457 14.2316 3.92529 14.422 4.34695C15.9804 3.68757 18.088 2.82542 19.9282 2.17462C21.2868 1.69414 22.8057 2.21792 22.9893 3.58935Z",
    fill: "#FFF0E1",
    stroke: "#FF7300",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewtravel);
export default __webpack_public_path__ + "static/media/newtravel.fd5b8afb47fef2ef41e2887516b1be73.svg";
export { ForwardRef as ReactComponent };